module.exports = __webpack_public_path__ + "media/images/favicon-38f064f63a321a99dad26df3d8c25f81.ico";